import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Artists.css";
import ConcreteImg from "../../imgs/artists-imgs/concrete.jpg";
import JerryGImg from "../../imgs/artists-imgs/jerry-garcia.jpeg";
import DoknowsworldImg from "../../imgs/artists-imgs/Doknowsworld.png";
import ChonaeImg from "../../imgs/artists-imgs/chonae.jpg";

const artistsData = [
  { name: "Chona E", image: ChonaeImg, link: "/ChonaE", status: "Comedian" },
  { name: "Concrete", image: ConcreteImg, link: "/Concrete", status: "Comedian" },
  { name: "Doknowsworld", image: DoknowsworldImg, link: "/Doknowsworld", status: "Comedian" },
  { name: "Jerry Garcia", image: JerryGImg, link: "/JerryG", status: "Comedian" },
].sort((a, b) => a.name.localeCompare(b.name));

function Artists() {
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const handleScroll = () => {
      const scrollLeft = slider.scrollLeft;
      const cardWidth = slider.offsetWidth;
      setActiveIndex(Math.round(scrollLeft / cardWidth));
    };

    slider.addEventListener("scroll", handleScroll);
    return () => slider.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToIndex = (index) => {
    if (!sliderRef.current) return;
    const cardWidth = sliderRef.current.offsetWidth;
    sliderRef.current.scrollTo({ left: index * cardWidth, behavior: "smooth" });
  };

  const renderCard = (artist, index) => (
    <Link to={artist.link} className="artist-link">
      <div className="artist-img-wrapper">
        <img src={artist.image} alt={artist.name} className="artist-image" />
        <div className="artist-overlay" />
        <span className="artist-index" aria-hidden="true">
          {String(index + 1).padStart(2, "0")}
        </span>
        <div className="artist-details">
          <p className="artist-status">{artist.status}</p>
          <h3 className="artist-card-name">{artist.name}</h3>
          <span className="artist-cta">
            <span className="artist-cta-label">View Profile</span>
            <span className="artist-cta-arrow" aria-hidden="true">→</span>
          </span>
        </div>
      </div>
    </Link>
  );

  return (
    <section className="artists-section">
      <header className="artists-header">
        <span className="artists-eyebrow">
          Our Roster
        </span>
        <h1 className="artists-title">Meet the Comedians</h1>
      </header>

      {/* Desktop Grid */}
      <div className="artists-grid">
        {artistsData.map((artist, index) => (
          <div key={index} className="artist-card">
            {renderCard(artist, index)}
          </div>
        ))}
      </div>

      {/* Mobile Slider */}
      <div className="artist-slider-wrapper">
        <div className="artist-slider" ref={sliderRef}>
          {artistsData.map((artist, index) => (
            <div key={index} className="artist-slide">
              {renderCard(artist, index)}
            </div>
          ))}
        </div>

        <div className="slider-indicators">
          {artistsData.map((_, index) => (
            <button
              key={index}
              type="button"
              className={`dot ${index === activeIndex ? "active" : ""}`}
              onClick={() => scrollToIndex(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Artists;
